import type { FC } from 'react'
import { type IconButtonProps, IconButton as MuiIconButton } from '@mui/material'

type Props = Omit<IconButtonProps, 'color' | 'variant'> & Readonly<{ variant: NonNullable<IconButtonProps['variant']> }>

/**
 * `IconButton` is just a wrapper for MuiIconButton that:
 * - deprecates usage of `color` prop
 * - makes `variant` prop mandatory
 *
 * TODO: make variant prop mandatory on MUI level
 * @see https://cybusio.atlassian.net/browse/CC-4499
 */
export const IconButton: FC<Props> = MuiIconButton
